/* eslint-disable radix */
import * as React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import { Box, muiBankTheme } from '@ally/metronome-ui'

interface ProgressCircleProps {
  progress: number
}

interface ProgressBoxProps {
  offset: string
}

const RADIUS = 25
const CIRCUMFERENCE = Math.PI * (RADIUS * 2)

const StyledBox = styled(Box)<ProgressBoxProps>`
  ${({ offset }): string => `
    {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      svg {
        width: 60px;
        height: 60px;
      }

      circle.bg {
        fill: none;
        stroke-width: 8px;
        stroke: #d1adc6;
      }

      circle.progress {
        fill: none;
        stroke-width: 8px;
        transform: rotate(-90deg);
        transform-origin: 50% 50%;
        stroke-dasharray: ${CIRCUMFERENCE};
        stroke-dashoffset: ${offset};
        stroke: #8a3475;
      }

      text {
        color: #8a3475;
        font-weight: bold;
      }
    }
  `}
`
const getTextPosition = (progress: number): string => {
  if (progress === 100) {
    return '20%'
  }
  if (progress < 10) {
    // istanbul ignore next
    return '35%'
  }
  return '30%'
}

const ProgressCircle: React.FC<ProgressCircleProps> = (
  props,
): React.ReactElement => {
  const { progress } = props
  const percentage = 100 * progress
  const percentageRounded = percentage.toFixed(0)
  const title = `${percentageRounded} percent progress`

  return (
    <ThemeProvider theme={muiBankTheme}>
      <StyledBox offset={`${CIRCUMFERENCE * (1 - progress)}`}>
        <svg
          viewBox="0 0 60 60"
          role="img"
          aria-labelledby="progress-wheel-title"
        >
          <title id="progress-wheel-title">{title}</title>
          <circle className="bg" cx="30" cy="30" r={RADIUS} />
          <circle className="progress" cx="30" cy="30" r={RADIUS} />
          <text x={getTextPosition(parseInt(percentageRounded))} y="35">
            {`${percentageRounded}%`}
          </text>
        </svg>
      </StyledBox>
    </ThemeProvider>
  )
}

export default ProgressCircle
